export const QUICKEN_DOWNLOAD_URI = '';
// prettier-ignore
export const CONSOLIDATED_REPORTING_URI_1 = `${import.meta.env.VITE_ADDITIONAL_SERVICES_OKTA}/login/sessionCookieRedirect?token=`;
// prettier-ignore
export const CONSOLIDATED_REPORTING_URI_2 = `&redirectUrl=${import.meta.env.VITE_ADDITIONAL_SERVICES_OKTA}/home/bessemertrust2_blackdiamond_1/0oae4gznzaaUZvE1F0y6/48243`;
// prettier-ignore
export const SECURE_MAIL_URI = `${import.meta.env.VITE_ADDITIONAL_SERVICES_MESSAGES}/l.aspx?provider=OKTA&sessiontoken=`;
export const BILLPAY_URI = '';
